'use client';

import { Stack } from '@mui/material';

import { PASSWORDS_DO_NOT_MATCH_MESSAGE } from './authChallengeError';
import { InlineErrorField } from './inlineErrorField';

// The "new password" + "confirm new password" pair shared by the forced
// password change and the forgot-password reset. Confirm shows the mismatch
// message inline; the parent owns the values and any server-side new-password
// error.
export const NewPasswordFields = ({
  idPrefix,
  newPassword,
  confirmPassword,
  onNewPasswordChange,
  onConfirmPasswordChange,
  newPasswordAutoFocus = false,
  newPasswordError = null,
}: {
  idPrefix: string;
  newPassword: string;
  confirmPassword: string;
  onNewPasswordChange: (value: string) => void;
  onConfirmPasswordChange: (value: string) => void;
  newPasswordAutoFocus?: boolean;
  newPasswordError?: string | null;
}) => (
  <Stack sx={{ gap: '12px' }}>
    <InlineErrorField
      id={`${idPrefix}-new-password`}
      label='New password'
      type='password'
      autoFocus={newPasswordAutoFocus}
      value={newPassword}
      onChange={onNewPasswordChange}
      errorMessage={newPasswordError}
    />
    <InlineErrorField
      id={`${idPrefix}-confirm-password`}
      label='Confirm new password'
      type='password'
      value={confirmPassword}
      onChange={onConfirmPasswordChange}
      errorMessage={
        confirmPassword.length > 0 && confirmPassword !== newPassword
          ? PASSWORDS_DO_NOT_MATCH_MESSAGE
          : null
      }
    />
  </Stack>
);
